import { useContext, useEffect, useState } from "react";
import { DataProvider } from "../../store/ContextProvider";
import Loading from "../../pages/Loading";

function EmployerEntry({ candidate }) {
    const { BeURL, showAlert } = useContext(DataProvider);
    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState("");
    const [loading, setLoading] = useState(true);
    const [isAddingComment, setIsAddingComment] = useState(false)

    useEffect(() => {
        fetch(`${BeURL}/candidate/${candidate._id}/comments`, { credentials: "include" })
            .then(res => res.json())
            .then(data => {
                if (data.success) setComments(data.comments);
                setLoading(false);
            })
            .catch(err => {
                console.log("Error in fetching candidate comments:",err)
                showAlert("Trouble in connecting to Server! please try again later.")
            })
    }, [candidate._id, BeURL]);

    const handleAddComment = async () => {
        if (!newComment.trim()) return;
        setIsAddingComment(true)
        try{
            const res = await fetch(`${BeURL}/candidate/${candidate._id}/comment`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ message: newComment })
            });
            const data = await res.json();
            setIsAddingComment(false)
            if (data.success) {
                setComments(data.comments);
                setNewComment("");
            }
            showAlert(data.message);
        }
        catch (err) {
            setIsAddingComment(false)
            console.log("Error in adding comments:",err)
            showAlert("Trouble in connecting to Server! please try again later.")
        }

    };

    if (loading) return <Loading/>;

    return (
        <div className="p-4 my-3 mx-auto bg-white rounded-2xl shadow-md space-y-6">

            {/* Comments Section */}
            <div>
                <h2 className="text-lg font-semibold ">Comments</h2>
                <p className="text-sm text-gray-500 ">{comments.length > 0 ? comments.length : 0} comments </p>
                <div className="space-y-2 max-h-48 overflow-y-auto border p-2 rounded bg-gray-50">
                    {comments.length === 0 && <p className="text-sm text-gray-500">No comments yet</p>}
                    {comments.reverse().map((c, idx) => (
                        <div key={idx} className="p-2 border-b">
                            <p className="text-sm">{c.message}</p>
                            <p className="text-xs text-gray-500">
                                — {c.commentedByName || ""} on {new Date(c.commentedOn).toLocaleString("en-GB")}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="flex mt-2 gap-2">
                    <input
                        type="text"
                        value={newComment}
                        onChange={e => setNewComment(e.target.value)}
                        placeholder="Write a comment..."
                        className="flex-1 border rounded p-2"
                    />
                    <button
                        onClick={handleAddComment}
                        className="bg-primary-400 text-white px-4 py-2 rounded-lg hover:bg-primary-300 text-xs md:text-sm lg:text-md"
                    >
                        {isAddingComment ? "Adding..." : "Add"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default EmployerEntry;
